import Component from 'flarum/Component';
import avatar from 'flarum/helpers/avatar';
import username from 'flarum/helpers/username';

export default class ChatMentionDropdown extends Component {
    view() {
        const { suggestions, selectedIndex, onSelect } = this.attrs;

        if (!suggestions || !suggestions.length) return null;

        return (
            <ul className="ChatMentionDropdown">
                {suggestions.map((item, i) => (
                    <li
                        className={'ChatMentionDropdown-item' + (i === selectedIndex ? ' active' : '')}
                        onmousedown={(e) => {
                            e.preventDefault();
                            onSelect(item);
                        }}
                    >
                        {item.type === 'game' ? this.renderGame(item) : this.renderUser(item)}
                    </li>
                ))}
            </ul>
        );
    }

    renderUser(user) {
        return [
            avatar(user),
            <span className="ChatMentionDropdown-name">{username(user)}</span>
        ];
    }

    renderGame(game) {
        return [
            game.image_url
                ? <img className="ChatMentionDropdown-game-image" src={game.image_url} alt="" />
                : <span className="ChatMentionDropdown-game-icon">{'\u{1F3B2}'}</span>,
            <span className="ChatMentionDropdown-name">{game.name}</span>
        ];
    }
}
